/* Superoom - First Drop Kit offer module.

   The buy box is an option list, not a toggle: one radio group, the selected option expands, the
   rest collapse to a line. Selecting an option only changes what the single CTA posts.

   THE FREE MINI IS NO LONGER CHOSEN HERE. It is chosen in the cart drawer
   (assets/superoom-cart-gift.js), which also hides this module's chip row. So this module adds the
   subscription and NOTHING else: no mini line, no "First Drop Kit mini" label. See state.mini and
   the pair branch below - both were deliberately emptied, and neither is dead code to be tidied
   away. Put a default back and the drawer opens on "Your free gift" with one already picked, which
   is precisely the decision the cart is meant to be asking for.

   THE CTA IS ONE ELEMENT THAT MOVES. Every option carries an empty [data-sro-slot]; render() puts
   the [data-sro-act] block into whichever option is selected. That puts the button immediately
   under the thing just configured, and leaves the one-off rows BELOW it instead of sitting between
   the last decision and the commit. It has to be one element rather than a copy per option: the
   sticky mobile bar holds a reference to this button and clicks it, and duplicates would give it
   four candidates and a stale one to click.

   QUANTITY BELONGS TO THE ONE-TIME OPTIONS ONLY, which is what offers[x].qty says. Buying two of
   the same bottle on a monthly plan stopped being a real intent when two formulas got its own
   tier, so the stepper is hidden there and the button carries the price. On a one-off the stepper
   shows, the button says only "Add to cart", and the running total goes in that option's own price
   slot - a button reading "Add one bottle - 99.98" while adding two was the thing that prompted it.

   QUANTITY RESETS WHEN THE OPTION CHANGES. Otherwise a 2 left over from the one-time row silently
   doubles the next thing selected, and the option headers would keep showing a multiplied price
   for something no longer chosen.

   THE BUTTON PRICE IS THE LINE TOTAL, NOT THE UNIT PRICE. At quantity 1 it prints Liquid's own
   formatted string, which is the only one guaranteed to match the market's money format; only
   above 1 does it format the multiplied amount here, from the integer minor units and the cart's
   currency. If Intl is unavailable it shows the unit price rather than a wrong total.

   EVERY OPTION HAS ITS OWN TICK LIST and render() shows the one whose key matches the selection.
   A reassurance that is not true of the thing selected is worse than none: free delivery is real
   at 69.99 and false at 39.99.

   TIER TWO POSTS A REAL POWER COUPLE PRODUCT, and the two minis it earns are claimed in the cart.

   THE HERO ARROWS CLICK THE THUMBNAILS rather than setting the hero directly. One source of truth
   for the current shot, so the arrows and the thumbnail strip cannot disagree.

   It also keeps a hidden [data-sro-price] in sync, which the sticky mobile bar reads.

   Also carries a page-wide interceptor for plain /cart/add links so the Mini Collection band opens
   the drawer instead of navigating to the cart page. */
(function () {
  function afterAdd() {
    var drawer = document.getElementById('cart-drawer');
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
    if (drawer && typeof drawer.show === 'function') { drawer.show(); return; }
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    window.location.href = '/cart';
  }

  function addItems(items, btn, busy) {
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.style.pointerEvents = 'none'; btn.textContent = busy || 'Adding...'; }
    function restore() { if (btn) { btn.disabled = false; btn.style.pointerEvents = ''; btn.textContent = label; } }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        restore();
        if (!res.ok) { alert((res.body && res.body.description) || 'Sorry, that could not be added.'); return; }
        afterAdd();
      })
      .catch(function () { restore(); window.location.href = '/cart'; });
  }

  function init(root) {
    if (root.dataset.sroReady) return;
    root.dataset.sroReady = '1';
    var el = root.querySelector('[data-sro-data]');
    if (!el) return;
    var D = JSON.parse(el.textContent);

    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var state = {
      opt: 'sub',
      /* Deliberately null. This used to default to D.minis[0], which meant the buy box silently
         chose the gift before the shopper reached the cart. The drawer is where that choice lives
         now, so nothing is pre-selected here. */
      mini: null,
      pair: (D.pairs[0] || {}).variant || null,
      /* The SECOND 15ml, picked on this row rather than in the drawer. Null until they choose, and
         cleared whenever the option or the quantity leaves the state where it means anything. */
      second: null,
      qty: 1
    };

    /* "Any 2 minis, GBP35" is a BXGY that takes two_mini_off the SECOND 15ml, once per cart, so the
       running total is n bottles at list less one discount from two bottles on. Liquid sends 0
       outside GBP because the rule is a fixed amount in the shop currency; other markets then see
       plain multiplication, which is what their cart will actually charge. */
    function miniTotal(n) {
      var unit = (D.offers['15ml'] || {}).amount;
      if (typeof unit !== 'number') return null;
      return unit * n - (n >= 2 ? (D.two_mini_off || 0) : 0);
    }
    function secondLive() { return state.opt === '15ml' && state.qty >= 2; }

    var act = q('[data-sro-act]');

    var ghost = document.createElement('span');
    ghost.setAttribute('data-sro-price', '');
    ghost.style.display = 'none';
    root.appendChild(ghost);

    function pairObj() {
      return D.pairs.filter(function (p) { return String(p.variant) === String(state.pair); })[0] || D.pairs[0];
    }
    function miniObj() {
      return D.minis.filter(function (m) { return String(m.id) === String(state.mini); })[0];
    }
    function offer() {
      return D.offers[state.opt] || D.offers.sub;
    }

    function money(minor) {
      if (typeof minor !== 'number' || !isFinite(minor) || !D.currency) return null;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency', currency: D.currency
        }).format(minor / 100);
      } catch (e) { return null; }
    }

    function priceLabel(o, qty) {
      var n = qty == null ? state.qty : qty;
      if (o === D.offers['15ml'] && n > 1) {
        var mt = money(miniTotal(n));
        if (mt) return mt;
      }
      if (n > 1) {
        var amount = o.amount;
        if (o === D.offers.pair) {
          var p = pairObj();
          if (p && typeof p.price === 'number') amount = p.price;
        }
        var total = money(amount * n);
        if (total) return total;
      }
      return o.price;
    }

    function closePops(except) {
      qa('[data-sro-pop]').forEach(function (p) {
        if (p !== except) p.hidden = true;
      });
    }

    function showShot(btn) {
      var hero = q('[data-sro-hero]');
      if (hero && btn.dataset.sroThumb) { hero.src = btn.dataset.sroThumb; hero.srcset = ''; }
      qa('[data-sro-thumb]').forEach(function (b) { b.setAttribute('aria-current', String(b === btn)); });
    }

    function syncEqMini(chip) {
      var slot = q('[data-sro-eqmini]');
      if (!slot || !chip) return;
      var src = chip.getAttribute('data-sro-mini-img');
      if (!src) return;
      var img = slot.querySelector('img');
      if (!img) {
        img = document.createElement('img');
        img.alt = '';
        img.loading = 'lazy';
        slot.appendChild(img);
      }
      if (img.getAttribute('src') === src) return;
      img.removeAttribute('srcset');
      img.setAttribute('src', src);
    }

    function render() {
      qa('[data-sro-opt]').forEach(function (o) {
        o.setAttribute('aria-checked', String(o.dataset.sroOpt === state.opt));
      });
      var chosenChip = null;
      qa('[data-sro-mini]').forEach(function (b) {
        var on = b.dataset.sroMini === String(state.mini);
        b.setAttribute('aria-checked', String(on));
        if (on) chosenChip = b;
      });
      syncEqMini(chosenChip);
      qa('[data-sro-pair]').forEach(function (b) {
        b.setAttribute('aria-checked', String(b.dataset.sroPair === String(state.pair)));
      });
      qa('[data-sro-gift]').forEach(function (g) {
        g.hidden = g.dataset.sroGift !== String(state.pair);
      });

      var pick = q('[data-sro-2nd]');
      if (pick) pick.hidden = !secondLive();
      qa('[data-sro-second]').forEach(function (b) {
        b.setAttribute('aria-checked', String(b.dataset.sroSecond === String(state.second)));
      });

      var host = q('[data-sro-opt="' + state.opt + '"] [data-sro-slot]');
      if (act && host && act.parentNode !== host) host.appendChild(act);

      // One tick list per option, so nothing is promised that is not true of the selection.
      qa('[data-sro-ticks]').forEach(function (t) {
        t.hidden = t.dataset.sroTicks !== state.opt;
      });

      var o = offer();
      var price = priceLabel(o);

      var qw = q('[data-sro-qtywrap]');
      if (qw) qw.style.display = o.qty ? '' : 'none';

      var qv = q('[data-sro-qtyval]');
      if (qv) qv.textContent = state.qty;

      // A one-off shows its running total in its own price slot; everything else keeps the unit
      // price Liquid printed, so an abandoned quantity cannot leave a stale number behind.
      qa('[data-sro-optprice]').forEach(function (b) {
        var key = b.dataset.sroOptprice;
        var od = D.offers[key];
        if (!od) return;
        b.textContent = key === state.opt ? priceLabel(od) : od.price;
      });

      var cta = q('[data-sro-cta]');
      if (cta) cta.textContent = o.qty ? o.cta : (o.cta + ' · ' + price + (o.unit || ''));
      ghost.textContent = price + (o.unit || '');
      closePops();
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-sro-opt],[data-sro-mini],[data-sro-second],[data-sro-pair],[data-sro-info],[data-sro-qty],[data-sro-thumb],[data-sro-nav],[data-sro-add]');
      if (!t || !root.contains(t)) return;

      if (t.hasAttribute('data-sro-info')) {
        e.preventDefault(); e.stopPropagation();
        var pop = root.querySelector('[data-sro-pop="' + t.dataset.sroInfo + '"]');
        if (!pop) return;
        var open = pop.hidden;
        closePops(pop);
        pop.hidden = !open;
        return;
      }
      if (t.hasAttribute('data-sro-add')) {
        e.preventDefault();
        addItems([{ id: Number(t.dataset.sroAdd), quantity: 1 }], t);
        return;
      }
      if (t.hasAttribute('data-sro-nav')) {
        e.preventDefault(); e.stopPropagation();
        var thumbs = qa('[data-sro-thumb]');
        if (!thumbs.length) return;
        var cur = 0;
        thumbs.forEach(function (b, i) { if (b.getAttribute('aria-current') === 'true') cur = i; });
        var step = Number(t.dataset.sroNav) || 1;
        showShot(thumbs[(cur + step + thumbs.length) % thumbs.length]);
        return;
      }
      if (t.hasAttribute('data-sro-qty')) {
        e.stopPropagation();
        state.qty = Math.max(1, Math.min(9, state.qty + Number(t.dataset.sroQty)));
        if (!secondLive()) state.second = null;
        render();
        return;
      }
      if (t.hasAttribute('data-sro-mini')) { e.stopPropagation(); state.mini = t.dataset.sroMini; render(); return; }
      /* Tapping the chosen one again clears it, so a shopper who changes their mind can go back to
         two of this page's formula without reloading. Two of the same still comes to 35.00. */
      if (t.hasAttribute('data-sro-second')) {
        e.stopPropagation();
        state.second = (String(state.second) === t.dataset.sroSecond) ? null : t.dataset.sroSecond;
        render();
        return;
      }
      if (t.hasAttribute('data-sro-pair')) { e.stopPropagation(); state.pair = t.dataset.sroPair; render(); return; }
      if (t.hasAttribute('data-sro-thumb')) { showShot(t); return; }
      if (t.hasAttribute('data-sro-opt')) { state.opt = t.dataset.sroOpt; state.qty = 1; state.second = null; render(); }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var t = e.target.closest('[data-sro-opt],[data-sro-mini],[data-sro-pair]');
      if (!t || !root.contains(t)) return;
      e.preventDefault();
      if (t.hasAttribute('data-sro-mini')) state.mini = t.dataset.sroMini;
      else if (t.hasAttribute('data-sro-pair')) state.pair = t.dataset.sroPair;
      else { state.opt = t.dataset.sroOpt; state.qty = 1; state.second = null; }
      render();
    });

    document.addEventListener('click', function (e) { if (!root.contains(e.target)) closePops(); });

    var ctaEl = q('[data-sro-cta]');
    if (ctaEl) ctaEl.addEventListener('click', function () {
      var o = offer();
      var items = [];

      if (state.opt === 'sub') {
        var main = { id: o.variant, quantity: state.qty };
        if (o.selling_plan) main.selling_plan = o.selling_plan;
        /* No mini and no gift label. state.mini is null by design (see above), so miniObj() finds
           nothing; the branch is kept because a chip click still sets state.mini, and if the chip
           row is ever brought back this keeps working. */
        var m = miniObj();
        if (m) {
          main.properties = {};
          main.properties[D.kit_property_label] = m.name + ' 15ml mini';
          items.push(main);
          items.push({ id: m.id, quantity: state.qty, properties: { '_first_drop_kit': '1', 'Included free with': D.kit_name } });
        } else {
          items.push(main);
        }
      } else if (state.opt === 'pair') {
        var p = pairObj();
        if (!p) return;
        var line = { id: p.variant, quantity: state.qty };
        if (p.plan) line.selling_plan = p.plan;
        /* A Power Couple earns TWO free minis. They are claimed in the cart drawer, one tile each,
           rather than posted here - otherwise both are chosen for the shopper and the drawer has
           nothing left to offer. */
        items.push(line);
      } else if (state.opt === '15ml' && state.second && state.qty >= 2) {
        /* Quantity counts BOTTLES, and the picked second takes one of them: 2 posts 1 + 1, 3 posts
           2 + 1. Two lines, not two adds, so the cart applies the discount in one pass. */
        items.push({ id: o.variant, quantity: state.qty - 1 });
        items.push({ id: Number(state.second), quantity: 1 });
      } else {
        items.push({ id: o.variant, quantity: state.qty });
      }

      addItems(items, ctaEl);
    });

    render();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    var link = t.closest('a[href*="/cart/add"]');
    if (!link || link.hasAttribute('data-sro-no-ajax')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    var href = link.getAttribute('href') || '';
    var id = href.match(/[?&]id=(\d+)/);
    if (!id) return;
    var qty = href.match(/[?&]quantity=(\d+)/);
    var plan = href.match(/[?&]selling_plan=(\d+)/);
    var item = { id: Number(id[1]), quantity: qty ? Number(qty[1]) : 1 };
    if (plan) item.selling_plan = Number(plan[1]);
    e.preventDefault();
    addItems([item], link);
  });

  function boot() { Array.prototype.slice.call(document.querySelectorAll('[data-sro-root]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
